import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ModalDeleteItem from '../../Modal-Delete-Item';
import Audience from './Audience';
import { TabPaneStyles } from '../styles';
import { useKanban } from 'hooks/useKanban';

const TabPaneAudiences = ({ setStatus, audiences, setAudiences }) => {
  const { t: translate } = useTranslation();
  const { search } = window.location;
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const { kanban: paidMedia } = useKanban();
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [selectedAudience, setSelectedAudience] = useState(null);

  const toggleModal = () => {
    const willClose = isOpenModalDelete;
    setIsOpenModalDelete(!isOpenModalDelete);

    if (willClose) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const deleteAudience = async () => {
    return paidMedia.deleteTypeItem('audiences', selectedAudience.id);
  };

  return (
    <TabPaneStyles>
      <span>{translate('Audiences')}</span>
      <div className="d-flex flex-column gap-2">
        {audiences &&
          audiences.map((audience) => (
            <Audience
              key={audience.id}
              id={audience.id}
              name={audience.name}
              description={audience.description}
              setItems={setAudiences}
              index={audiences.findIndex((col) => col.id === audience.id)}
              isNew={audience.isNew}
              setSelectedItem={setSelectedAudience}
              setIsOpenModalDelete={setIsOpenModalDelete}
              setStatus={setStatus}
            />
          ))}
        <Button
          color="outline"
          style={{ width: '37.5rem' }}
          onClick={() =>
            setAudiences([
              ...audiences,
              { id: `temp-${audiences.length + 1}`, name: '', description: '', isNew: true },
            ])
          }
        >
          <i className="bx bx-plus" />
          {translate('Add audience')}
        </Button>
      </div>
      <ModalDeleteItem
        isOpen={isOpenModalDelete}
        toggle={toggleModal}
        item={selectedAudience}
        setItems={setAudiences}
        setStatus={setStatus}
        onDelete={deleteAudience}
        headerText="Delete audience"
        bodyText="Are you sure you want to delete the audience {{item}}?"
      />
    </TabPaneStyles>
  );
};

TabPaneAudiences.propTypes = {
  setStatus: PropTypes.func.isRequired,
  audiences: PropTypes.array.isRequired,
  setAudiences: PropTypes.func.isRequired,
};

export default TabPaneAudiences;
